import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { adminApi, formatApiError } from "@/admin/api";

const AuthContext = createContext(null);

export function AdminAuthProvider({ children }) {
  // null = checking, false = unauthenticated, object = authenticated
  const [user, setUser] = useState(() => {
    return localStorage.getItem("cad4_admin_token") ? null : false;
  });

  const check = useCallback(async () => {
    const token = localStorage.getItem("cad4_admin_token");
    if (!token) {
      setUser(false);
      return;
    }
    try {
      const { data } = await adminApi.get("/auth/me");
      setUser(data);
    } catch {
      localStorage.removeItem("cad4_admin_token");
      setUser(false);
    }
  }, []);

  useEffect(() => {
    check();
  }, [check]);

  const login = async (email, password) => {
    try {
      const { data } = await adminApi.post("/auth/login", { email, password });
      localStorage.setItem("cad4_admin_token", data.token);
      setUser({ email: data.email, name: data.name, role: "admin" });
      return { ok: true };
    } catch (err) {
      return { ok: false, error: formatApiError(err?.response?.data?.detail) || err.message };
    }
  };

  const logout = () => {
    localStorage.removeItem("cad4_admin_token");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, recheck: check }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAdminAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAdminAuth must be used inside AdminAuthProvider");
  return ctx;
}
